import { render } from "./otc_pharmacy_index.vue?vue&type=template&id=2436215c&scoped=true"
import script from "./otc_pharmacy_index.vue?vue&type=script&lang=js"
export * from "./otc_pharmacy_index.vue?vue&type=script&lang=js"

import "./otc_pharmacy_index.vue?vue&type=style&index=0&id=2436215c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2436215c"]])

export default __exports__